<ng-container>
  <router-outlet/>
</ng-container>
